/* eslint-disable */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import ReactHighChart from 'react-highcharts';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Tooltip } from 'react-tippy';
import Scrollbar from 'smooth-scrollbar-react';
import { CHART_TYPES } from '../../constants';

import lineChart from '../../assets/images/line_chart.svg';
import barChart from '../../assets/images/bar_chart.svg';
import lineChartSelected from '../../assets/images/line_chart_selected.svg';
import barChartSelected from '../../assets/images/bar_chart_selected.svg';

const HistoricalRateTab = ({ isWaterRate, isUseTaxElectionRate, unit, propertyID, fetchHistoricalRates, ownerId, taxingUnitChartType, buildLineChartConfig, parseFloatKeep, buildLineHChartConfig }) => {
  const [ historicalRates, setHistoricalRates ] = useState([]);
  const [ chartType, setChartType ] = useState();
  const [ hChartType, setHChartType ] = useState();

  const getData = async () => {
    const res = await fetchHistoricalRates({
      propertyID,
      taxingUnitID: unit.taxingUnitID,
      ownerId,
    });
    if (res && res.results) {
      setHistoricalRates(res.results);
    }
  };

  useEffect(() => {
    setChartType(CHART_TYPES.COLUMN);
    setHChartType(CHART_TYPES.COLUMN);
    getData();
  }, []);

  return (
    <div className='rate-container historical-container'>
      <Scrollbar alwaysShowTracks className='custom-scroll-wrapper'>
        <div className='sub-rate-value-container'>
          <div className='row sub-rate-container'>
            <div className='col col-3'>
              <span className='label'>
                {(isWaterRate(unit) && isUseTaxElectionRate(unit)) ? 'Tax Election' : 'No New Revenue'}
              </span>
            </div>
            <div className='col col-3'>
              <span className='label'>
                <span>Voter Approval Rate</span>
              </span>
            </div>
            <div className='col col-3'>
              <span className='label'>Proposed Rate</span>
            </div>
            <div className='col col-3'>
              <span className='label'>
                <span>Adopted Rate</span>
              </span>
            </div>
          </div>
          <div className='row sub-rate-container'>
            <div className='sub-rate-label-container'>
              {
                historicalRates.map(h => (
                  <span className='label' key={h.taxingUnitYr}>{h.taxingUnitYr}</span>
                ))
              }
            </div>
            <div className='col col-3'>
              {
                historicalRates.map(h => (
                  <div className='value' key={h.taxingUnitYr}>{(isWaterRate(unit) && isUseTaxElectionRate(unit)) ? h.mandatoryTaxElectionRate : h.effTaxRate}</div>
                ))
              }
            </div>
            <div className='col col-3'>
              {
                historicalRates.map(h => (
                  <div className='value' key={h.taxingUnitYr}>{h.rollbackRate}</div>
                ))
              }
            </div>
            <div className='col col-3'>
              {
                historicalRates.map(h => (
                  <div className='value' key={h.taxingUnitYr}>{h.proposedRate}</div>
                ))
              }
            </div>
            <div className='col col-3'>
              {
                historicalRates.map(h => (
                  <div className='value' key={h.taxingUnitYr}>{h.adoptedRate}</div>
                ))
              }
            </div>
          </div>
        </div>
      </Scrollbar>
      <div className='charts-flex-container'>
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ paddingLeft: 10 }}>Tax Rates</div>
            <div
              className='row'
              style={{ justifyContent: 'flex-end', paddingRight: 15 }}
            >
              <img
                alt='bar chart'
                src={chartType === CHART_TYPES.COLUMN ? barChartSelected : barChart}
                style={{ cursor: 'pointer', marginRight: '10px' }}
                onClick={() => setChartType(CHART_TYPES.COLUMN)}
              />
              <img
                alt='line chart'
                src={chartType === CHART_TYPES.LINE ? lineChartSelected : lineChart}
                style={{ cursor: 'pointer' }}
                onClick={() => setChartType(CHART_TYPES.LINE)}
              />
            </div>
          </div>

          {(chartType !== CHART_TYPES.COLUMN || taxingUnitChartType !== 'Hybrid') ?
            <ReactHighChart config={buildLineChartConfig(unit, chartType)} /> :
            <HighchartsReact
              highcharts={Highcharts}
              options={{ ...buildLineChartConfig(unit, chartType),
                credits: {
                  enabled: false,
                },
                lang: {
                  thousandsSep: ','
                }
              }}
            />
          }

          {parseInt(unit.freezeYr, 10) > 0 && (
            <Tooltip
              html={
                <div>
                            Your current taxes for this taxing unit are limited
                            by an exemption you qualified in
                  <span style={{ color: '#b7cd2a' }}> {unit.freezeYr} </span>
                            for property owners that are disabled or 65 years of
                            age or older. Your taxes are limited to not increase
                            above
                  <span style={{ color: '#b7cd2a' }}>
                    {' '}$
                    <NumberFormat
                      displayType={'text'}
                      thousandSeparator
                      value={parseFloatKeep(unit.freezeCeiling)}
                    />{' '}
                  </span>
                            unless certain new improvements are made to your
                            residence that are excluded from this limitation.
                </div>
              }
              position='bottom'
              trigger='mouseenter'
            >
              <div className='tag-container'>
                <span>Tax Limitation</span>
              </div>
            </Tooltip>
          )}
        </div>
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ paddingLeft: 10 }}>Historical Tax Rates</div>
            <div
              className='row'
              style={{ justifyContent: 'flex-end', paddingRight: 15 }}
            >
              <img
                alt='bar chart'
                src={hChartType === CHART_TYPES.COLUMN ? barChartSelected : barChart}
                style={{ cursor: 'pointer', marginRight: '10px' }}
                onClick={() => setHChartType(CHART_TYPES.COLUMN)}
              />
              <img
                alt='line chart'
                src={hChartType === CHART_TYPES.LINE ? lineChartSelected : lineChart}
                style={{ cursor: 'pointer' }}
                onClick={() => setHChartType(CHART_TYPES.LINE)}
              />
            </div>
          </div>
          <ReactHighChart config={buildLineHChartConfig(historicalRates, hChartType)} /> :
        </div>
      </div>

    </div>
  );
};

HistoricalRateTab.propTypes = {
  buildLineChartConfig: PropTypes.func.isRequired,
  buildLineHChartConfig: PropTypes.func.isRequired,
  fetchHistoricalRates: PropTypes.func.isRequired,
  isUseTaxElectionRate: PropTypes.func.isRequired,
  isWaterRate: PropTypes.func.isRequired,
  ownerId: PropTypes.any,
  parseFloatKeep: PropTypes.func.isRequired,
  propertyID: PropTypes.any,
  taxingUnitChartType: PropTypes.any,
  unit: PropTypes.any,
};

export default HistoricalRateTab;
